export default __webpack_public_path__ + "locales/ro/InfoPanel.json?hash=244f11dd1f4bbca7ec55e085f381d920";